import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledContainer = styled(Box)({
  width: "100%",
  border: "1px solid #ebebf7",
  borderRadius: "8px",
  height: "100%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  backgroundColor: "rgb(255, 255, 255)",
});

export const StyledHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: 48,
  display: "flex",
  alignItems: "center",
  "& svg": {
    color: "#363846",
  },
  [theme.breakpoints.down("xl")]: {
    height: 36,
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  lineHeight: "21px",
  color: "#363846",
  fontSize: 16,
  margin: theme.spacing(1, 0),
  [theme.breakpoints.down("xl")]: {
    fontSize: 14,
    lineHeight: 1,
  },
}));

export const StyledContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  borderTop: "1px solid #ebebf7",
  minHeight: 0,
  position: "relative",
  flex: 1,
  display: "flex",
  flexDirection: "column",
}));
